/**
 * Short unit-of-measure suffixes for the split-project modal's Units inputs (MOD-3972), per
 * the Figma ("9 Each" → "Ea", "30 LNFT" → "LF"). `unitOfMeasure` is free text on ProductInfo,
 * so unknown values fall back to the raw string rather than guessing.
 */
const ABBREVIATIONS: Record<string, string> = {
  each: 'Ea',
  lnft: 'LF',
  sqft: 'SF',
};

export function unitAbbreviation(unitOfMeasure: string | null | undefined): string {
  const trimmed = unitOfMeasure?.trim();
  if (!trimmed) {
    return '';
  }
  return ABBREVIATIONS[trimmed.toLowerCase()] ?? trimmed;
}
